<template>
  <div>

    <head>
      <meta charset="utf-8" />
      <title>Reset Password | Best Birdy</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Keep your finances and membership up to date" name="description" />
      <meta content="" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.svg">

      <!-- owl.carousel css -->
      <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

      <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

    </head>

    <body  @contextmenu.prevent class="auth-body-bg">

    <div>
      <div class="container-fluid p-0">
        <div class="row g-0">

          <div class="col-xl-8 col-lg-8">
            <div class="pt-lg-5 p-4 bg-overlay" :style="backgroundStyle">
              <div class="w-100">
                <div class="bg-overlay"></div>
                <div class="d-flex h-100 flex-column">

                  <div class="p-4 mt-auto">
                    <div class="row justify-content-center">
                      <div class="col-lg-7">
                        <div class="text-center">
                          <img :src="county_logo()" alt="Logo" class="img mb-3" style="width: 170px;">


                          <h4 class="mb-0 text-white"><i class="bx bxs-quote-alt-left text-success h1 align-middle me-3"></i><span>Right there for you</span></h4>
                          <p class="font-size-16 text-white mb-0">Billing system.</p>
                          <strong>-</strong>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end col -->

          <div class="col-xl-4 col-md-4">
            <div class="auth-full-page-content p-md-5 p-4">
              <div class="w-100">

                <div class="d-flex flex-column h-100">
                  <div class="mb-4 mb-md-5">
                    <a href="index.html" class="d-block auth-logo">
                      <img :src="county_logo" alt="" height="18" class="auth-logo-dark">
                      <img :src="county_logo" alt="" height="18" class="auth-logo-light">
                    </a>
                  </div>
                  <div class="my-auto">

                    <div class="mb-4">
                      <div class="avatar-md mx-auto">
                        <div class="avatar-title rounded-circle bg-light">
                          <i class="bx bxs-lock-open h1 mb-0 text-success"></i>
                        </div>
                      </div>
                    </div>

                    <div class="text-center">
                      <h4 class="text-success">Reset Password</h4>
                      <p class="text-muted mb-4">You are required to change your password. Please enter your new password below.</p>
                    </div>

                    <div class="mt-4">
                      <form @submit.prevent="changePassword">
                        <div class="mb-3">
                          <label for="newPassword" class="form-label fw-semibold">Enter Your New Password <span class="text-danger">*</span></label>
                          <div class="input-group auth-pass-inputgroup">
                            <input
                                v-model="password"
                                :type="showNewPassword ? 'text' : 'password'"
                                class="form-control"
                                id="newPassword"
                                placeholder="Enter your new password"
                                required>
                            <button
                                @click="togglePasswordVisibility('new')"
                                class="btn btn-light"
                                type="button"
                                id="new-password-addon">
                              <i :class="showNewPassword ? 'mdi mdi-eye-off-outline' : 'mdi mdi-eye-outline'"></i>
                            </button>
                          </div>
                        </div>

                        <div class="mb-3">
                          <label for="confirmPassword" class="form-label fw-semibold">Confirm Your New Password <span class="text-danger">*</span></label>
                          <div class="input-group auth-pass-inputgroup">
                            <input
                                v-model="confirmPassword"
                                :type="showConfirmPassword ? 'text' : 'password'"
                                class="form-control"
                                id="confirmPassword"
                                placeholder="Re-enter your new password"
                                required>
                            <button
                                @click="togglePasswordVisibility('confirm')"
                                class="btn btn-light"
                                type="button"
                                id="confirm-password-addon">
                              <i :class="showConfirmPassword ? 'mdi mdi-eye-off-outline' : 'mdi mdi-eye-outline'"></i>
                            </button>
                          </div>
                        </div>

                        <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                          <i class="mdi mdi-check-all me-2"></i>
                          {{message}}
                          <button type="button" class="btn-close" @click="alert.success = false"></button>
                        </div>

                        <div v-if="alert.info" class="alert alert-primary alert-dismissible fade show" role="alert">
                          <i class="mdi mdi-loading mdi-spin me-2"></i>
                          {{message}}
                        </div>

                        <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                          <i class="mdi mdi-alert me-2"></i>
                          {{message}}
                          <button type="button" class="btn-close" @click="alert.failed = false"></button>
                        </div>

                        <div class="mt-4 d-grid">
                          <button
                              type="submit"
                              class="btn btn-success waves-effect waves-light btn-lg"
                              :disabled="alert.info || !password || !confirmPassword">
                            <i class="bx bx-lock-open me-1"></i>
                            Reset Password
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div class="mt-4 mt-md-5 text-center">
                    <p class="mb-0 text-muted">© {{ fullYear }} Best Birdy. All rights reserved.</p>
                  </div>
                </div>


              </div>
            </div>
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container-fluid -->
    </div>

    </body>

  </div>
</template>



<script>

/* eslint-disable */

import {authUrl, county_logo, execute, getRight, login_bg} from "@/api";
import router from "@/router";

export default {
  name: "PasswordResetPage",
  data() {
    return{
      backgroundUrl: login_bg, // Dynamic URL
      deviceDetials:'',
      os: '',
      browser: '',
      screenResolution: '',
      cpuCores: '',
      memory: '',

      fullYear:'',
      message:'',

      // Password visibility toggles
      showNewPassword: false,
      showConfirmPassword: false,

      alert:{
        success: false,
        info: false,
        failed:false
      },

      password:'',
      confirmPassword:''
    }
  },
  mounted() {
    const currentDate = new Date();
    this.fullYear = currentDate.getFullYear();

    this.getDeviceDetails();
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.backgroundUrl})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      };
    }
  },
  methods: {
    county_logo() {
      return county_logo
    },

    togglePasswordVisibility(field) {
      if (field === 'new') {
        this.showNewPassword = !this.showNewPassword;
      } else if (field === 'confirm') {
        this.showConfirmPassword = !this.showConfirmPassword;
      }
    },

    getDeviceDetails() {
      // Operating System
      if (navigator.userAgent.indexOf('Win') !== -1) this.os = 'Windows';
      else if (navigator.userAgent.indexOf('Mac') !== -1) this.os = 'MacOS';
      else if (navigator.userAgent.indexOf('Linux') !== -1) this.os = 'Linux';
      else this.os = 'Unknown';

      // Browser
      if (navigator.userAgent.indexOf('Chrome') !== -1) this.browser = 'Chrome';
      else if (navigator.userAgent.indexOf('Firefox') !== -1) this.browser = 'Firefox';
      else if (navigator.userAgent.indexOf('Safari') !== -1) this.browser = 'Safari';
      else if (navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode) this.browser = 'Internet Explorer';
      else this.browser = 'Unknown';

      // Screen Resolution
      this.screenResolution = `${window.screen.width} x ${window.screen.height}`;

      // CPU Cores
      this.cpuCores = navigator.hardwareConcurrency || 'Unknown';

      // Memory
      this.memory = (navigator.deviceMemory || 'Unknown');

      this.deviceDetials = `os: ${this.os} | browser: ${this.browser} | screenResolution: ${this.screenResolution} | cpuCores: ${this.cpuCores} | memory: ${this.memory}`

    },

    changePassword() {
      // Reset alerts
      this.alert.failed = false;
      this.alert.success = false;
      this.alert.info = false;

      // Validation
      if (!this.password || !this.confirmPassword) {
        this.alert.failed = true;
        this.message = "Please fill in both password fields.";
        return;
      }

      // Check if passwords match
      if (this.password !== this.confirmPassword) {
        this.alert.failed = true;
        this.message = "Passwords do not match. Please try again.";
        return;
      }

      // Show loading state
      this.message = "Resetting your password...";
      this.alert.info = true;

      const data = new FormData();
      data.append("function", "changePassword");
      data.append("password", this.password);
      data.append("deviceDetails", this.deviceDetials);
      data.append("idNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, authUrl)
          .then((res) => {
            this.alert.info = false;

            if (res.data.success) {
              this.alert.success = true;
              this.message = "Password changed successfully! Redirecting to login...";

              // Clear form
              this.password = '';
              this.confirmPassword = '';

              // Redirect after 2 seconds
              setTimeout(() => {
                router.push('/');
              }, 2000);
            } else {
              this.alert.failed = true;
              this.message = res.data.message || "Failed to change password. Please try again.";
            }
          })
          .catch((e) => {
            this.alert.info = false;
            this.alert.failed = true;
            this.message = "An error occurred: " + (e.message || "Please try again later.");
            console.error("Password change error:", e);
          });
    }

  }
}

</script>

<style scoped>
.auth-full-bg {
  background-color: rgba(85, 110, 230, 0.25);
  display: flex;
  height: 100vh;
}

.auth-full-bg::before {
  content: "";
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
}

.auth-pass-inputgroup .btn {
  border-left: 0;
}

.auth-pass-inputgroup input {
  border-right: 0;
}

.avatar-md {
  height: 4rem;
  width: 4rem;
}

.avatar-title {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}
</style>